var map = {
	"./Botões Download@2x.png": 14793,
	"./Logo@2x.png": 38990,
	"./LogoTipo2.png": 16508,
	"./Logotipo.png": 30036,
	"./Mock@2x.png": 4675,
	"./Soyshare3.0.png": 79202,
	"./appStore.png": 58807,
	"./appStoreQrCode.png": 19785,
	"./bg-report-form.png": 31308,
	"./bx_bx-chart.png": 17715,
	"./dashboard/trending-down.png": 84342,
	"./dashboard/trending-up.png": 36745,
	"./date.png": 29463,
	"./del-logo-big.png": 36147,
	"./drag.png": 21045,
	"./dragIcon.png": 67726,
	"./duplicar.png": 34727,
	"./edit.png": 23943,
	"./emptyOptions.png": 9976,
	"./excluir.png": 19661,
	"./farm-report-icon.png": 76808,
	"./farmer-1.png": 70712,
	"./farmer-2.png": 45203,
	"./farmer-3.png": 6346,
	"./farmer-4.png": 91013,
	"./farmer-portal-reports.png": 32657,
	"./group.png": 11730,
	"./ico_calendario.png": 55967,
	"./ico_confirmar.png": 71324,
	"./ico_local.png": 27500,
	"./ico_responsavel.png": 78291,
	"./icone_map.png": 53532,
	"./inputArea.png": 60516,
	"./inputNumber.png": 14220,
	"./inputText.png": 79834,
	"./layouts/below header.png": 61065,
	"./layouts/boxed.png": 41011,
	"./layouts/dark horizontal.png": 31255,
	"./layouts/default horizontal.png": 37526,
	"./layouts/drawer nav.png": 23915,
	"./layouts/fixed.png": 93525,
	"./layouts/framed.png": 36914,
	"./layouts/full width.png": 69144,
	"./layouts/inside header horizontal.png": 18930,
	"./layouts/mini sidebar.png": 45894,
	"./layouts/no header mini sidebar.png": 82022,
	"./layouts/simple horizontal inside menu.png": 22504,
	"./layouts/top to header.png": 68324,
	"./layouts/vertical no header.png": 84529,
	"./location.png": 64318,
	"./logo-big-old.png": 48275,
	"./logo-big.png": 43147,
	"./logo-harvest-mini-white.png": 84272,
	"./logo-old.png": 90474,
	"./logo-white-old.png": 11710,
	"./logo-white.png": 68314,
	"./logo-white2.png": 16306,
	"./logo.png": 82806,
	"./logo2.png": 8886,
	"./marker.png": 62333,
	"./message.png": 84766,
	"./pentagon.png": 58487,
	"./pentagon_1.png": 53179,
	"./phone-sent.png": 95636,
	"./pin-map.png": 64107,
	"./playStore.png": 82826,
	"./playStoreQrCode.png": 5728,
	"./productivity-report.png": 78768,
	"./select.png": 51347,
	"./selectMultiple.png": 56439,
	"./selectOrder.png": 61435,
	"./selectTable.png": 10871,
	"./soyshare.png": 80447,
	"./timeline/atrasada.png": 57398,
	"./timeline/nao_planejada.png": 93412,
	"./timeline/planejada.png": 40243,
	"./timeline/realizada.png": 23996,
	"./upload.png": 82456,
	"./w-logo-old.png": 42194,
	"./w-logo.png": 18254,
	"./w-logo2.png": 42334,
	"./w-logo3.png": 94823,
	"./whatsapp.png": 92841,
	"./widget/birds.png": 93550,
	"./widget/bread.png": 4680,
	"./widget/building.png": 58440,
	"./widget/disc.png": 35171,
	"./widget/flying.png": 32525,
	"./widget/glass.png": 90422,
	"./widget/noodles.png": 47562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;